import { render, staticRenderFns } from "./BtnAddNewRec.vue?vue&type=template&id=fcb7788c&"
import script from "./BtnAddNewRec.vue?vue&type=script&lang=js&"
export * from "./BtnAddNewRec.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports